export enum EWidgetProductType {
  EDIT = "edit",
  CREATE = "create",
  DUPLICATE = "duplicate",
}
